import { ColonistRushIncentiveDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
import { sendRushIncentivePopupShown, sendRushIncentivePopupTryRushClicked } from '../../analytics/sendRushIncentivePopupAnalytic.ts';
const renderColonistRushIncentiveDialog = mountDialogUIReactComponent(ColonistRushIncentiveDialog);
export function showColonistRushIncentiveDialog(continuationAction, tryRushAction, continuationText) {
    sendRushIncentivePopupShown();
    renderColonistRushIncentiveDialog({
        continuationText: continuationText,
        onTryRush: ()=>{
            sendRushIncentivePopupTryRushClicked();
            tryRushAction();
        },
        onContinue: continuationAction
    });
}
